<template>
  <v-dialog
    v-model="active"
    persistent
    width="25%"
  >
    <template #activator="{ on, attrs }">
      <ASecondaryButton
        label="Editar"
        v-bind="attrs"
        v-on="on"
      />
    </template>
    <ACard>
      <v-card-title class="justify-center">
        Registro de vehículo
      </v-card-title>
      <v-card-text>
        <v-form>
          <v-autocomplete
            v-model="vehiculo.fk_idModeloVehiculo"
            label="Modelo"
            :items="modelos"
            item-value="id"
            item-text="nombre"
            background-color="primary"
            color="secondary"
            rounded
            filled
            dense
          >
            <template #item="{item, on, attrs}">
              <v-list-item
                v-bind="attrs"
                v-on="on"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.nombre }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ item.catMarca.title }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-autocomplete>
          <ASelect
            v-model="vehiculo.fk_idColorVehiculo"
            label="Color"
            :items="colores"
            item-value="id"
            item-text="title"
          />
          <ATextField
            v-model="vehiculo.placa"
            label="Placa"
          />
          <ATextField
            v-model="vehiculo.anio"
            label="Año"
          />
          <ATextField
            v-model="vehiculo.serievehiculo"
            label="Número de serie de vehículo"
          />
          <ATextField
            v-model="vehiculo.seriemotor"
            label="Número de serie del motor"
          />
          <ATextField
            v-model="vehiculo.aseguradora"
            label="Aseguradora"
          />
          <ADateInput
            v-model="vehiculo.fechaAdquisicion"
            label="Fecha"
          />
        </v-form>
      </v-card-text>
      <v-card-actions class="justify-center">
        <ASecondaryButton
          label="Cancelar"
          @click="closeDialog()"
        />
        <APrimaryButton
          label="Guardar"
          :loading="loading"
          :disabled="loading"
          @click="triggerSaveVehiculo()"
        />
      </v-card-actions>
    </ACard>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import ACard from '../atoms/ACard.vue';
import ADateInput from '../atoms/ADateInput.vue';
import APrimaryButton from '../atoms/APrimaryButton.vue';
import ASecondaryButton from '../atoms/ASecondaryButton.vue';
import ASelect from '../atoms/ASelect.vue';
import ATextField from '../atoms/ATextField.vue';

export default {
  components: {
    APrimaryButton,
    ACard,
    ATextField,
    ASelect,
    ASecondaryButton,
    ADateInput,
  },

  props: {
    updateData: {
      type: Object,
      default: () => null,
    },

    id: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      active: false,
      vehiculo: {
        fk_idPersonal: null,
        fk_idModeloVehiculo: 0,
        fk_idColorVehiculo: 0,
        anio: null,
        placa: '',
        fechaAdquisicion: '',
        seriemotor: '',
        serievehiculo: '',
        aseguradora: '',
        fk_idTipo: 1,
        fk_idUso: 1,
      },
      loading: false,
    };
  },

  computed: {
    ...mapGetters('modelo', {
      modelos: 'getModelos',
    }),

    ...mapGetters('color', {
      colores: 'getColores',
    }),
  },

  watch: {
    updateData: {
      handler(newValue) {
        this.vehiculo = { ...newValue };
      },
      immediate: true,
    },
  },

  methods: {
    ...mapActions('vehiculos', ['saveVehiculo', 'updateVehiculo']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),

    closeDialog() {
      this.active = false;
      if (!this.updateData) {
        this.vehiculo = {
          fk_idPersonal: null,
          fk_idModeloVehiculo: 0,
          fk_idColorVehiculo: 0,
          anio: null,
          placa: '',
          fechaAdquisicion: '',
          seriemotor: '',
          serievehiculo: '',
          aseguradora: '',
          fk_idTipo: 1,
          fk_idUso: 1,
        };
      } else {
        this.vehiculo = { ...this.updateData };
      }
    },

    async triggerSaveVehiculo() {
      this.loading = true;

      try {
        if (this.updateData) {
          await this.updateVehiculo(this.vehiculo);
        } else {
          this.vehiculo.fk_idPersonal = Number(this.id);
          await this.saveVehiculo(this.vehiculo);
        }
        this.SET_SNACKBAR_MESSAGE('Vehículo guardado.');
      } catch (error) {
        this.SET_SNACKBAR_MESSAGE('Ocurrió un error al guardar el vehículo');
      }

      this.closeDialog();

      this.loading = false;
    },
  },
};
</script>
